







import {Component, Vue} from 'vue-property-decorator';
import Login from '@/components/Login.vue'; // @ is an alias to /src
import Heading from '@/components/Heading.vue';
import LoggedIn from '@/components/LoggedIn.vue';

@Component({
  components: {
    Login,
    Heading,
    LoggedIn,
  },
})
export default class Home extends Vue {
  protected user: any = {
    isLoggedIn: false,
    ...(window as any).user,
  };
}
